const cleanVisualizationUrl = (url: string): string =>
  url.replace('visualizer', 'ai');

export { cleanVisualizationUrl };
